<section
  class="banner block"
  [ngClass]="colours().bg"
  [attr.aria-live]="theme() === NotificationTheme.ERROR ? 'polite' : undefined"
  [attr.role]="theme() === NotificationTheme.ERROR ? 'alert' : undefined"
>
  <div class="grid-max-width grid-col-12">
    <div
      class="col-1-12 ps-medium flex g-small"
      [class.flex--start]="!isCampaign()"
      [class.flex--center]="isCampaign()"
    >
      @if (colours().icon) {
        <fcom-icon
          [category]="IconLibrary.SVG_LIBRARY_NEW"
          [name]="colours().icon"
          [ngClass]="colours().iconColour"
        ></fcom-icon>
      }
      <div
        class="banner-text-wrapper flex font-body-1 font-body-medium"
        [class.flex-1]="!isCampaign()"
        [class.flex--column]="!horizontal()"
        [ngClass]="colours().text"
      >
        <div class="texts flex flex-1 flex--column g-xsmall">
          @if (title()) {
            <span class="texts-title font-body-medium-bold" data-testid="banner-title">{{ title() }}</span>
          }
          <ng-content />
          @if (!horizontal()) {
            @if (linkText() && linkUrl()) {
              <fcom-link
                data-testid="banner-primary-link"
                [ngClass]="colours().text"
                [href]="linkUrl()"
                [openInNewTab]="linkOpenInNewWindow()"
                [external]="linkOpenInNewWindow()"
                (beforeNavigation)="onLinkClick($event)"
                >{{ linkText() }}</fcom-link
              >
            }
          }
        </div>
        @if (horizontal()) {
          @if (linkText() && linkUrl()) {
            <div class="banner-link flex--end">
              <fcom-link
                data-testid="banner-primary-link"
                [ngClass]="colours().text"
                [href]="linkUrl()"
                [openInNewTab]="linkOpenInNewWindow()"
                [external]="linkOpenInNewWindow()"
                (beforeNavigation)="onLinkClick($event)"
                >{{ linkText() }}</fcom-link
              >
            </div>
          }
        }
      </div>

      @if (isClosable() && !isCampaign()) {
        <div class="banner-close-wrapper">
          <fcom-icon-button
            [icon]="{
              category: IconLibrary.SVG_LIBRARY_NEW,
              name: SvgLibraryIcon.CLOSE_DELETE,
            }"
            [aria]="{ label: i18n().closeAriaLabel | finLocalization }"
            [size]="IconButtonSize.SMALL"
            [theme]="IconButtonTheme.TERTIARY_GHOST"
            (clickBtn)="closeClick.emit($event)"
            data-testid="close-button"
          />
        </div>
      }
    </div>
  </div>
</section>
